var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackSettingsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M20 2c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v8.605A7 7 0 0 0 12.824 22L4.001 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 20V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h16Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "m20 4 .001 8.051a7 7 0 0 0-7.78 7.95L4 20V4h16Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "nonzero",
  d: "m18.15 24-.3-1.5c-.2-.083-.388-.17-.563-.262a4.352 4.352 0 0 1-.537-.338l-1.45.45-1-1.7 1.15-1a4.616 4.616 0 0 1-.05-.65c0-.2.017-.417.05-.65l-1.15-1 1-1.7 1.45.45c.183-.133.363-.246.538-.338.174-.091.362-.179.562-.262l.3-1.5h2l.3 1.5c.2.083.387.175.563.275.174.1.354.225.537.375l1.45-.5 1 1.75-1.15 1c.033.2.05.408.05.625 0 .217-.017.425-.05.625l1.15 1-1 1.7-1.45-.45a4.352 4.352 0 0 1-.538.338c-.175.091-.362.179-.562.262l-.3 1.5h-2Zm1-3c.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413s-.196-1.02-.587-1.413A1.926 1.926 0 0 0 19.15 17c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0 0 17.15 19c0 .55.196 1.02.588 1.413.391.391.862.587 1.412.587Z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#006C8E",
  fillRule: "evenodd",
  points: "9.5 16.5 16.5 12 9.5 7.5"
}))));
export default SvgPlaybackSettingsIcon;